/*
 * @Description: 房源维护列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2019-07-04 11:51:33
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import { Button, message, Divider, Popconfirm, Upload,Modal } from 'antd';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import { postFrom, config, transterQuery } from '../../axios';
import {dicHouseStatus, syncStatusIsMap} from '../../axios/dictionaries';
import MaintainAdd from './components/MaintainAdd';
import {handleExportParams, isPlatform} from '../../utils';
import JrApiLog from "../Other/JrApiLog";

export default class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                keyword: '',
                syncStatus:'',
                status: '',
                pageSize: 10,
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
        }

        let loginData = Cookies.get('loginData');
        if (loginData) { //校验登录是否失效
            loginData = JSON.parse(loginData);
            if (loginData.merchantId) {  //为商户人员添加商户id
                this.merchantId = loginData.merchantId || 0;
            }
        }
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_house_findHousePageList, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleJrApiLogInfo(tableName,id) {
        //console.log(this);
        this.jrApiLogRef.open(tableName,id);
    }

    handleEdit = (id) => { //编辑
        this.setState({ showAddModal: true });
        this.maintainAddRef.loadPack({ id });
        this.maintainAddRef.loadBuildingList();
    }

    handleRemove = (id) => { //删除
        this.setState({ tableLoading: false });
        let data = { houseId: id };
        postFrom({ url: config.API_house_deleteHouse, data }).then(res => {
            this.setState({ tableLoading: false });
            this.handleSearch();
        }).catch(err => {
            message.error(err.message || '删除失败');
            this.setState({ tableLoading: false });
        });
    }

    importProps = {
        action: config.API_house_houseImportData,
        accept: '.xls',
        showUploadList: false,
        beforeUpload: (file) => {
            message.loading(`${file.name}上传中...`);
        },
        onChange: (info) => {
            if (info.file.status === 'done') {
                let res = info.file.response;
                if (res.code === 0) {
                    message.success(`${info.file.name}文件导入成功`);
                    this.handleSearch()
                } else {
                    
                    if(Array.isArray(res.data)){
                        Modal.error({
                            className:'importModal',
                            title: res.message || `${info.file.name}文件导入失败`,
                            content: <div style={{whiteSpace:'pre',maxHeight:'80vh',overflow:'auto'}}>{res.data.join('\n')}</div> ,
                        });
                    }else{
                        message.error(res.message || `${info.file.name}文件导入失败`);
                    }
                }
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name}文件上传失败`);
            }
        },
    };


    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            showAddModal,
        } = this.state;

        this.importProps.headers = { ...(handleExportParams() || {}) };

        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                        <AuthButton authkey="c-1-3" type="primary" icon="plus" onClick={() => { this.setState({ showAddModal: true }); this.maintainAddRef.loadBuildingList(); }}>新增</AuthButton>
                        <AuthButton authkey="c-1-5" type="primary" icon="export" href={`${config.API_house_houseExprotDate}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            导出
                        </AuthButton>
                        <AuthButton authkey="c-1-6" type="primary" icon="download" href={`${config.API_house_houseImportTemplate}?${transterQuery(handleExportParams() || {})}`}>
                            导入模板下载
                        </AuthButton>
                        <AuthButton authkey="c-1-7">
                            <Upload {...this.importProps}><Button type="primary" icon="import">批量导入</Button></Upload>
                        </AuthButton>
                    </div>
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <TableDOM
                    columns={columns({ current, handleEdit: this.handleEdit, handleRemove: this.handleRemove,handleJrApiLogInfo:this.handleJrApiLogInfo.bind(this) })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                    scroll={{x: 1500}}
                />
                <MaintainAdd
                    onRef={ref => this.maintainAddRef = ref}
                    visible={showAddModal}
                    handleCancel={() => { this.setState({ showAddModal: false }) }}
                    handleGetList={this.handleSearch}
                />
                <JrApiLog ref={ref=>{
                    this.jrApiLogRef=ref;
                }}/>
            </PageWrap>
        )
    }


}

const searchData = () => {
    let data =  [
    {
        tagName: 'Select',
        formConfig: { name: 'syncStatus' },
        attribute: { placeholder: '请选择同步状态', style: { width: '140px' } },
        optionData: [{ title: '全部', value: '' }].concat(syncStatusIsMap), //.concat(dicHouseStatus)
        notResult: '',
    },{
        tagName: 'Select',
        formConfig: { name: 'status' },
        attribute: { placeholder: '请选择租赁状态', style: { width: '140px' } },
        optionData: [{ title: '全部', value: '' }].concat(dicHouseStatus),
        notResult: '',
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'keyword' },
        attribute: { placeholder: '输入关键字', style: { width: '160px' } },
        title: `在${handleExportParams().merchantId ? '' : '商户简称、'}小区/楼栋、房号内模糊查询`
    },
]

   /* data = data.filter(e => {
        if(isPlatform()){
            return true;
        }
        if (e.formConfig.name === 'syncStatus') {
            return false;
        }
        return true;
    });*/

    return data;
};

const columns = ({ handleEdit, handleRemove,handleJrApiLogInfo }) => [
    {
        title: '房源编号',
        dataIndex: 'houseNo'
        , width:200 ,fixed: 'left'
    },
    {
        title: '房号',
        dataIndex: 'roomNo'
        , width:80 ,fixed: 'left'
    },
    {
        title: '小区/楼栋',
        dataIndex: 'buildingName'
        , width:200
    },
    {
        title: '楼层',
        dataIndex: 'floor'
        , width:60
    },
    {
        title: '户型',
        dataIndex: 'layout'
        , width:180
    },
    {
        title: '朝向',
        dataIndex: 'direct'
    },
    {
        title: '面积（m²）',
        dataIndex: 'area'
    },
    // {
    //     title: '同步状态 | 建融Id',
    //     dataIndex: 'name33',
    //     render(text, record, index) {
    //         return <span>
    //                 <div>{record.jrRoomId ? "同步成功" : "未同步"}</div>
    //             {
    //                 record.jrRoomId
    //                     ? <React.Fragment>
    //                         <div>{record.jrRoomId ? record.jrRoomId : ''}</div>
    //                     </React.Fragment>
    //                     : null
    //             }
    //             </span>
    //     }
    // },
    // {
    //     title: '建融户型Id',
    //     dataIndex: 'jrRoomTypeId',
    // },
    {
        title: '租赁状态',
        dataIndex: 'status',
        render(text, record, index) {
            let now = dicHouseStatus.find(item => item.value === text);
            if (now)
                return <span style={{ color: now.color }}>{now.title}</span>;
            return null
        }
    },
    {
        title: '商户简称',
        dataIndex: 'shortName'
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 200,
        fixed: 'right',
        render(text, record, index) {
            const rentLink = {
                pathname: '/admin/rentContract/list',
                state: { houseId: record.id }
            }
            return <span>
                <AuthButton authkey="c-1-2">
                    <span className="showClickDetail" onClick={() => { handleEdit(record.id) }}>编辑</span>
                </AuthButton>
                {/*<AuthButton authkey="c-1-8">*/}
                {/*    <Divider type="vertical" />*/}
                {/*   <span className="showClickDetail" onClick={() => { handleJrApiLogInfo("house",record.id) }}>建融日志</span>*/}
                {/*</AuthButton>*/}

                <AuthButton authkey="c-1-4">
                    <Divider type="vertical" />
                    <Popconfirm placement="top" title={"确定删除吗?"} onConfirm={() => { handleRemove(record.id) }} okText="删除" cancelText="不了">
                        <span className="showClickDetail">删除</span>
                    </Popconfirm>
                </AuthButton>
                <Divider type="vertical" />
                <Link to={rentLink}>查看合同</Link>
            </span>
        }
    }
];


// WEBPACK FOOTER //
// ./src/page/House/Maintain.js